export type ScaReason = 'purchase' | 'renew' | 'selection' | 'creation';
